import { intercomWidgetRight } from 'components/LiveClass/utils/consts';

export default function getRightSeparation() {
  const hasIntercom = document.getElementsByClassName('intercom-app').length > 0;
  return hasIntercom ? intercomWidgetRight : 20;
}
